"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userGroupsExtractor = void 0;
var userGroupsExtractor = function (members, accessibleCategories) {
    var groupMap = {};
    var groups = members.selectedUsers.reduce(function (accumulator, selected) {
        if (accumulator[selected.user.id] === undefined) {
            accumulator[selected.user.id] = members.groups.reduce(function (acc, group) {
                // Checking if selected user is member of category
                if ((group.category.members || []).findIndex(function (member) { return member.id === selected.user.id; }) > -1) {
                    var excluded = true;
                    // Check if admin can remove user from category
                    var categoryIndex = accessibleCategories.findIndex(function (accessible) { return accessible.category.id === group.category.id; });
                    if (categoryIndex > -1) {
                        excluded = false;
                        acc.push({
                            groupId: group.category.id,
                            userUuid: selected.user.uuid
                        });
                    }
                    else if (!groupMap[group.category.type]) {
                        groupMap[group.category.type] = true;
                    }
                }
                return (group.groups || []).reduce(function (a, g) {
                    // Checking if selected user is member of group
                    if ((g.members || []).findIndex(function (member) { return member.id === selected.user.id; }) > -1) {
                        var excluded = true;
                        var category = accessibleCategories.find(function (accessible) { return accessible.category.id === g.categoryId; });
                        if (category) {
                            // Check if admin can remove user from group
                            var groupIndex = category.groups.findIndex(function (group) { return group.id === g.id; });
                            if (groupIndex > -1) {
                                excluded = false;
                                a.push({ groupId: g.id, userUuid: selected.user.uuid });
                            }
                            else if (!groupMap[g.type]) {
                                groupMap[g.type] = true;
                            }
                        }
                        else if (!groupMap[g.type]) {
                            groupMap[g.type] = true;
                        }
                    }
                    return a;
                }, acc);
            }, []);
        }
        return accumulator;
    }, {});
    return [groupMap, groups];
};
exports.userGroupsExtractor = userGroupsExtractor;
